
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';

import { FormGroup, Label, Input, FormFeedback, FormText, Button, Row, Col } from 'reactstrap';
import Checkbox from './checkbox';
import { API_ENDPOINT } from '../../../constants';
import defaultProfilePicture from '../../../assets/images/user.png';



class DoctorListComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: null
        };
    }


    render() {
        return (
            <div className='doctor-list-component-wrap'>
                {this.props.label ? <Label size="sm" className={this.props.error ? "required" : ""}>{this.props.label}{this.props.haveValidation ? <span className="required-label-span">*</span> : null}</Label> : null}

                <div className='doctor-list-component-items-wrap'>
                    {this.props.values && this.props.values.length ? this.props.values.map((item, idx) => {
                        const selected = this.props.value && this.props.value.indexOf(item.value) !== -1;
                        if (!this.state.filter || (this.state.filter && item?.name?.indexOf(this.state.filter) == 0))
                            return (
                                <div
                                    key={idx}
                                    className={selected ? 'colleague-item-wrap selected-item' : 'colleague-item-wrap'}
                                    onClick={(e) => {
                                        e?.stopPropagation?.();
                                        let value = this.props.value;
                                        if (!value) {
                                            value = [];
                                        }

                                        let idx = value.indexOf(item.value);
                                        if (idx == -1) {
                                            value.push(item.value);
                                        } else {
                                            value.splice(idx, 1);
                                        }

                                        this.props.onChange(value);
                                        this.forceUpdate();
                                    }}
                                >
                                    <div className='colleague-data-wrap'>
                                        <div className='colleague-profile-pic-wrap'>
                                            <img alt='profile pic' src={item?.profilePicture ? API_ENDPOINT + item.profilePicture : defaultProfilePicture} />
                                        </div>
                                        <div className='colleague-name-wrap'>
                                            <div className='colleague-name'>{item.name}</div>
                                            <div className='colleague-username'>{item.username}</div>
                                        </div>

                                    </div>
                                    <div>
                                        <Checkbox
                                            disabled={this.props.disabled || item.disabled}
                                            checked={this.props.value && this.props.value.indexOf(item.value) !== -1}
                                            onChange={(e) => {
                                                return
                                                e?.stopPropagation?.();
                                                let value = this.props.value;
                                                if (!value) {
                                                    value = [];
                                                }

                                                let idx = value.indexOf(item.value);
                                                if (idx == -1) {
                                                    value.push(item.value);
                                                } else {
                                                    value.splice(idx, 1);
                                                }

                                                this.props.onChange(value);
                                                this.forceUpdate();

                                            }}
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                            )
                    })
                        :
                        null
                    }
                </div>
            </div>


        );
    }
}

export default DoctorListComponent;